import axios from 'axios';
import API_CONFIG from './api';

// Create axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_CONFIG.getBaseURL(),
  withCredentials: true, // Always include cookies
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
